import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import './funkcionalitaAdministratora.scss';
import routes from '../../../../../routing/routes';
import splitCisloLegMaterialu from '../../../../../function/splitCisloLegMaterialu';
import { StadiumMaterialuEnum } from '../../../../../model/legislativnyMaterial/StadiumMaterialu';
import LegislativnyMaterialDetail
  from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokListRequest from '../../../../../model/pracovnyKrok/PracovnyKrokListRequest';
import ModalRestartProcessInstance from './component/ModalRestartProcessInstance';
import ModalCancelVyjadrenia from './component/ModalCancelVyjadrenia';
import PracovnyKrokEnum from '../../../../../model/pracovnyKrok/PracovnyKrokEnum';
import pracovnyKrokAvailable from '../../../../../function/pracovnyKrokFunctions';
import { isFinalState } from '../../../../../function/getLatestStadium';

interface Props {
  legMaterial: LegislativnyMaterialDetail;
  pracovneKroky: PracovnyKrokListRequest;
  reloadDetail?: () => void;
  reloadPracovneKroky: () => void;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void;
}

const FunkcionalitaAdministratora = ({
  legMaterial,
  pracovneKroky,
  reloadDetail,
  reloadPracovneKroky,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(legMaterial.cisloLegislativnehoMaterialu);
  const pracovnyKrokMpk = pracovnyKrokAvailable(pracovneKroky, PracovnyKrokEnum.PRECHOD_MPK);
  const pracovnyKrokVyjadrenia = pracovnyKrokAvailable(pracovneKroky, PracovnyKrokEnum.PRECHOD_VYJADRENIA);
  return legMaterial.stadium && (
    <div className="material-detail-funkcionalita-administratora">
      {(legMaterial.stadium.hodnota === StadiumMaterialuEnum.MPK || pracovnyKrokMpk) && (
        <Link
          className="admin-funkcionalita__button"
          key="zmena-konfiguracie-mpk"
          size="small"
          to={legMaterial.stadium.hodnota === StadiumMaterialuEnum.MPK
            ? routes.procesy.admin.mpk.config.withParams(type, year, index)
            : routes.procesy.admin.mpk.start.withParams(type, year, index, pracovnyKrokMpk.pracovnyKrokId)}
          type="link"
        > {legMaterial.stadium.hodnota === StadiumMaterialuEnum.MPK ? 'Zmena konfigurácie Pripomienkového konania'
          : 'Prechod do štádia Pripomienkové konanie'}
        </Link>
      )}

      {(legMaterial.stadium.hodnota === StadiumMaterialuEnum.VYJADRENIA || pracovnyKrokVyjadrenia) && (
        <Link
          className="admin-funkcionalita__button"
          key="zmena-konfiguracie-vyjadreni"
          size="small"
          to={legMaterial.stadium.hodnota === StadiumMaterialuEnum.VYJADRENIA
            ? routes.procesy.admin.vyjadrenia.config.withParams(type, year, index)
            // eslint-disable-next-line max-len
            : routes.procesy.admin.vyjadrenia.start.withParams(type, year, index, pracovnyKrokVyjadrenia.pracovnyKrokId)}
          type="link"
        > {legMaterial.stadium.hodnota === StadiumMaterialuEnum.VYJADRENIA
          ? 'Zmena konfigurácie Vyjadrení'
          : 'Prechod do štádia Vyjadrenia k predbežnej informácii'}
        </Link>
      )}

      {((legMaterial.typ.kod === 'AktEU')
        && (legMaterial.stadium.hodnota !== StadiumMaterialuEnum.PROCES_UKONCENY)) && (
        <Link
          className="admin-funkcionalita__button"
          key="zmena-gestora-a-spolugestorov"
          size="small"
          to={routes.procesy.admin.gestor.withParams(type, year, index)}
          type="link"
        > Zmena gestora a spolugestorov
        </Link>
      )}

      {isFinalState(legMaterial.stadium.hodnota)
        && (
          <ModalRestartProcessInstance
            legMaterial={legMaterial}
            description={'Proces bude spustený, pričom sa dostane do počiatočného štádia, ale nebudú odoslané '
              + 'notifikácie, nebude vytvorený záznam v histórii a nebude preindexovaný. To znamená, že v zoznamoch '
              + 'sa bude stále javiť ako ukončený, ale detail procesu bude môcť zobraziť iba administrátor a osoba '
              + 'zodpovedná za počiatočné štádium. Po spustení bude nutné vykonať funkcionalitu '
              + ' "Zmena štádia materiálu", aby sa proces dostal do korektného stavu.'}
            reloadDetail={reloadDetail}
            confirmActionQuestion="Naozaj si prajete znovu spustiť legislatívny proces k zvolenému materiálu?"
            setIsDropdownOpened={setIsDropdownOpened}
          />
        )}

      {(legMaterial.stadium.hodnota !== StadiumMaterialuEnum.PROCES_UKONCENY
          && legMaterial.stadium.hodnota !== StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE)
        && (
          <Link
            className="admin-funkcionalita__button"
            key="zmena-stadia-materialu"
            size="small"
            to={routes.procesy.admin.zmenaStadiaMaterialu.withParams(type, year, index)}
            type="link"
          > Zmena štádia materiálu
          </Link>
        )}

      <Link
        className="admin-funkcionalita__button"
        key="notifikacie"
        size="small"
        to={routes.procesy.admin.notifikacie.withParams(type, year, index)}
        type="link"
      > Notifikácie
      </Link>

      {(legMaterial.stadium.hodnota === StadiumMaterialuEnum.MPK
        || (legMaterial.stadium.hodnota === StadiumMaterialuEnum.VYJADRENIA)) && (
        <div className="admin-funkcionalita__divider" />)}

      {pracovneKroky && (legMaterial.stadium.hodnota === StadiumMaterialuEnum.MPK) && (
        <Link
          className="admin-funkcionalita__button admin-funkcionalita__button--danger"
          key="zrusenie-mpk"
          size="small"
          to={routes.procesy.admin.mpk.cancel.withParams(type, year, index)}
          type="link"
        >Zrušiť Pripomienkové konanie
        </Link>
      )}
      {pracovneKroky && (legMaterial.stadium.hodnota === StadiumMaterialuEnum.VYJADRENIA) && (
        <ModalCancelVyjadrenia
          key="zrusit-vyjadrenie"
          label="Zrušiť vyjadrenia"
          confirmActionQuestion='Naozaj si prajete zrušiť štádium "Vyjadrenia k predbežnej informácii"?'
          confirmActionDescription={'Po vykonaní tejto funkcionality bude ukončené štádium '
            + '"Vyjadrenia k predbežnej informácii". K materiálu nebudú môcť používatelia '
            + 'pridávať ďalšie vyjadrenia a aktuálne štádium materiálu sa zmení na "Príprava materiálu".'}
          legMaterial={legMaterial}
          reloadDetail={reloadDetail}
          reloadPracovneKroky={reloadPracovneKroky}
          className="admin-funkcionalita__button admin-funkcionalita__button--danger"
          setIsDropdownOpened={setIsDropdownOpened}
        />
      )}
    </div>
  );
};
export default FunkcionalitaAdministratora;
